import React from 'react'

const ChangePlan = ({ width, height }) => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 14.855 15.085"
      >
        <path
          data-name="Path 936"
          d="M8.719 5.42a1.234 1.234 0 0 0-1.164-.82H6.6a1.1 1.1 0 0 0-.236 2.178l1.455.317a1.235 1.235 0 0 1-.264 2.441h-.823a1.234 1.234 0 0 1-1.164-.822M7.144 4.6V3.362m0 7.405V9.534M2 14.085V11.44h2.643"
          transform="translate(.138 .332)"
          style={{
            fill: 'none',
            stroke: '#b1b1b1',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
          }}
        />
        <path
          data-name="Path 937"
          d="M14.134 6.111a6.876 6.876 0 0 1-12.05 5.66M.618 8.642a6.876 6.876 0 0 1 12.05-5.66"
          transform="translate(.051 .166)"
          style={{
            fill: 'none',
            stroke: '#b1b1b1',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
          }}
        />
        <path
          data-name="Path 938"
          d="M12.147.5v2.647H9.5"
          transform="translate(.572 .166)"
          style={{
            fill: 'none',
            stroke: '#b1b1b1',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
          }}
        />
      </svg>
    </div>
  )
}

export default ChangePlan
